import type { VariationComponent } from "~types/types";
import {
    type IntegrityStatus,
    checkItemArrayIntegrity,
    checkItemIntegrity,
    checkMediaIntegrity,
} from "~utils/moduleIntegrity";

const MINIMUM_STORY_COUNT = 2;
const MAX_STORY_COUNT = 4;

export default function integrityCheck({
    items,
}: VariationComponent): IntegrityStatus {
    if (!items?.length || items.length < MINIMUM_STORY_COUNT) {
        return [`Requires at least ${MINIMUM_STORY_COUNT} stories`];
    }

    const primaryStoryErrorsMedia = checkMediaIntegrity([items[0]]).map(
        (message) => `Primary Story: ${message}`
    );

    const primaryStoryErrors = checkItemIntegrity(items[0], ["headline"]).map(
        (message) => `Primary Story: ${message}`
    );

    const secondaryStoryErrors = checkItemArrayIntegrity(
        items.slice(1, MAX_STORY_COUNT),
        ["headline"]
    ).map((message) => `Secondary Story: ${message}`);

    return [
        ...primaryStoryErrors,
        ...primaryStoryErrorsMedia,
        ...secondaryStoryErrors,
    ];
}
